<template>
  <LayoutPublic>
    <NavBarPublic />
    <HeroSection :data-hero="dataHero" />
    <CalloutSection />
    <DesignSection />
    <LayananSection />
    <!-- <FeaturesSection /> -->
    <BeritaSection page="home" />
    <FooterPublic />
  </LayoutPublic>
</template>

<script>
import swal from 'sweetalert'
import LayoutPublic from '../../views/layouts/Public.vue'
import NavBarPublic from '../../components/layout/NavBarPublic.vue'
import HeroSection from '../../components/layout/HeroSection.vue'
import CalloutSection from '../../components/layout/CalloutSection.vue'
// import FeaturesSection from '../../components/layout/FeaturesSection.vue'
import BeritaSection from '../../components/layout/BeritaSection.vue'
import DesignSection from '../../components/layout/DesignSection.vue'
import LayananSection from '../../components/layout/LayananSection.vue'
import FooterPublic from '../../components/layout/FooterPublic.vue'

export default {
	data(){
		return {
			dataHero: {
				title: 'Aplikasi SiPeDuLi Jembrana',
				desc: 'Sistem Pelayanan Administrasi Kependudukan Online Masyarakat Jembrana',
				action: 'login',
				img: 'home'
			}
		}
	},
	components: {
		LayoutPublic, NavBarPublic, HeroSection, CalloutSection, 
		// FeaturesSection, 
		BeritaSection, DesignSection, LayananSection, FooterPublic
	},
	mounted() {
		document.querySelector('body').scrollIntoView()
	},
}
</script>